import { Navigate, Route, Routes } from 'react-router-dom'
import { AppLayout } from './components/AppLayout'
import { RequireAdmin, RequireAuth } from './session'
import { LoginPage } from './pages/auth/LoginPage'
import { WelcomePage } from './pages/auth/WelcomePage'
import { BlockedPage } from './pages/auth/BlockedPage'
import { DayPage } from './pages/DayPage'
import { SearchByTimePage } from './pages/SearchByTimePage'
import { RoomSlotsPage } from './pages/RoomSlotsPage'
import { BookingFormPage } from './pages/BookingFormPage'
import { BookingDonePage } from './pages/BookingDonePage'
import { MeetingsPage } from './pages/MeetingsPage'
import { MeetingPage } from './pages/MeetingPage'
import { AdminRoomsPage } from './pages/admin/AdminRoomsPage'
import { AdminPoliciesPage } from './pages/admin/AdminPoliciesPage'
import { AdminUsersPage } from './pages/admin/AdminUsersPage'
import { AdminLayout } from './pages/admin/AdminLayout'
import { NotFoundPage } from './pages/NotFoundPage'

/**
 * Маршруты.
 *
 * Вход отдельным деревом: там нет сессии, а значит нет и каркаса с меню.
 * Всё остальное живёт под RequireAuth.
 */
export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/blocked" element={<BlockedPage />} />

      <Route
        path="/welcome"
        element={
          <RequireAuth>
            <WelcomePage />
          </RequireAuth>
        }
      />

      <Route
        element={
          <RequireAuth>
            <AppLayout />
          </RequireAuth>
        }
      >
        <Route index element={<DayPage />} />
        <Route path="/search" element={<SearchByTimePage />} />
        <Route path="/rooms/:roomId" element={<RoomSlotsPage />} />
        <Route path="/book" element={<BookingFormPage />} />
        <Route path="/bookings/:bookingId/edit" element={<BookingFormPage />} />
        {/* Экран 3.4 «Готово»: что произошло с участниками после создания брони. */}
        <Route path="/booked/:bookingId" element={<BookingDonePage />} />
        <Route path="/meetings" element={<MeetingsPage />} />
        {/* Экран 2.12. Сюда ведут ссылки «Открыть встречу» из всех писем, поэтому
            маршрут обязан существовать: catch-all ниже молча увёл бы человека
            на общее расписание, где свою встречу ещё надо найти. */}
        <Route path="/meetings/:bookingId" element={<MeetingPage />} />

        <Route
          path="/admin"
          element={
            <RequireAdmin>
              <AdminLayout />
            </RequireAdmin>
          }
        >
          <Route index element={<Navigate to="/admin/rooms" replace />} />
          <Route path="rooms" element={<AdminRoomsPage />} />
          <Route path="policies" element={<AdminPoliciesPage />} />
          <Route path="users" element={<AdminUsersPage />} />
        </Route>

        {/*
          Неизвестный адрес — это страница «такой страницы нет», а не тихий переход
          на день. Стоит внутри каркаса намеренно: у человека остаётся меню, и он
          уходит куда хотел, а не гадает, что случилось. Неавторизованного отсюда
          заберёт RequireAuth и после входа вернёт на этот же адрес.
        */}
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  )
}
